import React from 'react'

const CheckBox = ({ name, value, isChecked, handleCheckboxClick}) => (
  <label>
    <input
      type="checkbox"
      name={name}
      value={value}
      checked={isChecked}
      onChange={handleCheckboxClick}
    />
  </label>
)

export default CheckBox
